// TestKitsDropdownMultiSelect.tsx
import React, { useState, useCallback } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

import { SelectChangeEvent } from '@mui/material';

interface DropDownMultiselectProps {
	data: any[];
	selectedData: any[]; // Ensure this is properly typed as an array
	handleSelectedData: (data: any[]) => void;
	error?: string;
	size: 'small';
}

const TestKitsDropdownMultiSelect: React.FC<DropDownMultiselectProps> = ({
	data,
	selectedData,
	handleSelectedData,
	error,
	size,
}) => {
	const [currentSelections, setCurrentSelections] = useState<string[]>(() =>
		selectedData.map((item) => item.testKitName)
	);

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
	};

  const getSelectedTestKit = (testKitName: string[]) => {
		const selectedTestKit = data.filter((item) => {
			return testKitName.includes(item.testKitName);
		});
		return selectedTestKit;
	};

  const handleChange = (event: any) => {
		const {
			target: { value },
		} = event;
		handleSelectedData(getSelectedTestKit(value));
	};

  const formatData = () => {
		const formattedData = selectedData.map((item) => {
			return item.testKitName;
		});
		return formattedData;
  };

	return (
		<div>
			<FormControl sx={{ width: 360 }} error={error !== ''}>
				<Select
					size={size}
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					multiple
					value={formatData()}
					onChange={handleChange}
					renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
				>
					{data.map((item, index) => (
						<MenuItem
            key={`${item.name}-${index}`}
							value={item.testKitName}
						>
							<Checkbox
								checked={
									formatData().indexOf(item.testKitName) > -1
								}
							/>
							<ListItemText primary={item.testKitName} />
						</MenuItem>
					))}
				</Select>
				<FormHelperText>{error}</FormHelperText>
			</FormControl>
		</div>
	);
};

export default TestKitsDropdownMultiSelect;
